var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.agree_text)}}),_vm._v(" "),(_vm.hasVideo)?[_vm._v(_vm._s(_vm.$tr('videoInterview.checkVideo.videoAgree')))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }